document.addEventListener('DOMContentLoaded', function () {
  var lists = document.querySelectorAll('.usp-bar__list');

  lists.forEach(function (list) {
    var items = list.querySelectorAll('.usp-bar__item');
    if (items.length <= 1) return;

    var index = 0;

    items.forEach(function (item) { item.classList.remove('is-active'); });
    items[0].classList.add('is-active');

    setInterval(function () {
      if (window.innerWidth > 920) {
        items.forEach(item => item.classList.add('is-active'));
        return;
      }

      var oldItem = items[index];

      // remove active class → triggers fade-out
      oldItem.classList.remove('is-active');

      // wait for fade-out before switching
      setTimeout(function () {
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');  // triggers fade-in
      }, 350); // matches CSS transition time
    }, 4000);
  });
});
